<template>
  <router-link
    :to="to"
    :title="title"
    :class="`btn custom-pointer btn-radius ${
      btnName != '' ? '' : 'akkurate-small'
    } ${classes}`"
    style="text-decoration: none"
  >
    {{ btnName }}

    <font-awesome-icon class="ms-2" v-if="icon != ''" :icon="['fas', icon]" />
  </router-link>
</template>

<script>
export default {
  name: "LinkButton",
  props: {
    to: {
      type: String,
      required: true,
    },
    classes: {
      type: String,
      default: "",
      required: false,
    },
    btnName: {
      type: String,
      default: "",
      required: false,
    },
    icon: {
      type: String,
      default: "",
      required: false,
    },
    title: {
      type: String,
      default: "",
      required: false,
    },
  },
};
</script>
